import { derived, writable } from "svelte/store"

type ScreenSizes = "mobile" | "tablet" | "desktop"
export type ReaderFrameMode = "compact" | "framed"

export const responsiveBreakpoints = {
    tablet: 601,
    readerFramedMin: 721,
    desktop: 1154,
} as const

function mediaQueryStore(query: string) {
    const watcher = window.matchMedia(query)
    const store = writable(watcher.matches)

    watcher.addEventListener("change", (event) => store.set(event.matches))

    return store
}

const tabletStore = mediaQueryStore(
    `only screen and (min-width: ${responsiveBreakpoints.tablet}px)`,
)
const desktopStore = mediaQueryStore(
    `only screen and (min-width: ${responsiveBreakpoints.desktop}px)`,
)
const framedReaderStore = mediaQueryStore(
    `only screen and (min-width: ${responsiveBreakpoints.readerFramedMin}px)`,
)

export const deviceSize = derived([tabletStore, desktopStore], ([tablet, desktop]): ScreenSizes => {
    if (tablet && desktop) return "desktop"
    if (tablet && !desktop) return "tablet"
    return "mobile"
})

/**
 * Reader-specific layout mode. Compact readers replace the framed position
 * header with an in-scroll contents button, so overlays must provide their own
 * top safe-area clearance.
 */
export const readerFrameMode = derived(
    framedReaderStore,
    (framed): ReaderFrameMode => (framed ? "framed" : "compact"),
)

export const readingFrameHeaderHeight = writable(0)

//Debug
// deviceSize.subscribe((d) => console.log("Device size: ", d))
// console.log("init device:", get(deviceSize))
